import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import React from "react";
import { useState, useEffect } from "react";
import Image from "next/image";
import upIcon from "@images/ic_drop@2x.png";
import DownIcon from "@images/ic_drop_down@2x.png";
import { useRouter } from "next/router";

interface contentsType {
  id: number;
  question: string;
  answer: string;
  isShow: boolean;
  slotNode?: any;
}
type Props = {
  list: contentsType[];
  moreList?: contentsType[] | undefined;
  hideMoreButton?: boolean;
  itemStyle?: any
};
const Index = (props: Props) => {
  const router = useRouter();

  const { t, i18n } = useTranslation("home");
  const [showViewMore, setShowViewMore] = useState(false);
  const [datas, setDatas] = useState<contentsType[]>([]);
  const viewMore = () => {
    setDatas([...datas, ...(props.moreList || [])]);
    setShowViewMore(true);
  };

  useEffect(() => {
    setDatas(props.list);
    if (props.hideMoreButton) {
      setShowViewMore(true);
    }
  }, []);

  const openAnswer = (index: any, e: any) => {
    datas[index].isShow = !datas[index].isShow;
    setDatas([...datas]);
  };
  return (
    <div className={`${styles.faqs} animate-box`}>
      <div className={styles.faqsContainer}>
        <h2 className={styles.title}>{t("faqs")}</h2>

        {datas.map((item, index) => (
          <div className={`${styles.item} item1`} style={{...props.itemStyle}} key={item.id}>
            <div
              className={styles.question}
              onClick={(e) => openAnswer(index, e)}
            >
              <div className={styles.question1}>{t(`${item.question}`)}</div>

              {/* <span className={styles.downArrow}></span> */}
              {/* <div > */}
              <Image
                lazyBoundary="10px"
                alt=""
                src={item.isShow ? upIcon : DownIcon}
                className={styles.down}
                width={12}
                height={12}
              ></Image>
              {/* </div> */}
            </div>
            <div
              className={styles.answer}
              style={{ display: item.isShow ? "block" : "none" }}
            >
              {item.slotNode ? item.slotNode : t(`${item.answer}`)}
            </div>
          </div>
        ))}
      </div>
      {!showViewMore ? (
        <div className="text-center">
          <button className={styles.viewMore} onClick={viewMore}>
            {t("View More")}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default Index;
